const Separator = () => {
  return (
    <>
      <div className="relative">
        <div aria-hidden="true" className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex justify-center"></div>
      </div>
    </>
  );
};

export default Separator;
